import React from "react";

export default function SectionCard({ title, description, tag }) {
  return (
    <div className="card p-4">
      <div className="flex items-start justify-between gap-2">
        <p className="text-sm font-semibold text-slate-900">{title}</p>
        {tag && (
          <span className="rounded-full bg-amber-100 px-2 py-1 text-[10px] font-semibold text-amber-700">
            {tag}
          </span>
        )}
      </div>
      <p className="mt-2 text-sm text-slate-600">{description}</p>
    </div>
  );
}
